import { type ColumnSort, type OnChangeFn, type SortingState, getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { ChangeLog } from "@/graphql/codegen/graphql"
import { useChangeLogColumns } from "@/screens/ChangeLog/hooks/useChangeLogColumns"

interface ChangeLogTableProps {
  data: ChangeLog[]
  fetching: boolean
  scrollHandler: () => void
  tableContainerRef?: Ref<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  sorting: ColumnSort[]
  error?: Error
}

const ChangeLogTable: FC<ChangeLogTableProps> = ({
  data,
  error,
  scrollHandler,
  tableContainerRef,
  fetching,
  onSortingChange,
  sorting,
}) => {
  const columns = useChangeLogColumns()

  return (
    <AerosBaseTable<ChangeLog>
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: fetching,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        container: {
          ref: tableContainerRef,
          onScroll: scrollHandler,
        },
        bodyRow: {
          className: "hover:bg-primary-100 cursor-pointer",
        },
      }}
      noDataMessage='No change log found'
    />
  )
}

export default ChangeLogTable
